import React, {forwardRef, useCallback} from "react";

import {Checkbox} from "antd";
import {SellerListType} from "../../../api/apiTypes";
import {CheckboxGroupProps} from "antd/es/checkbox";
import {useTranslation} from "react-i18next";
import {queries} from "../../../api/queries";
import {useDataAll} from "../../../api/useDataAll";
import {removeExistingParamsArrayValue} from "../../../common/fns";
import {useSearchParams} from "react-router-dom";
import TimeFilter from "./TimeFilter";

interface Props extends CheckboxGroupProps {
  timeStart?: number;
  timeEnd?: number;
}

const SellerTimeFilter = forwardRef(({value, timeStart, timeEnd}: Props, ref) => {
  const [_, setSearchParams] = useSearchParams();
  const {t} = useTranslation(["shipping"]);
  const {listData, isLoading} = useDataAll<SellerListType>(queries.shop.list, {
    ordering: "name"
  });
  
  const handleChangeChecked = (checkedValues: any[]) => {
    console.log("checked = ", checkedValues);
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, "shipping_shop__uuid__in", checkedValues),
      shipping_shop__uuid__in: checkedValues
    }));
  };
  
  const handleFilterByMinute = useCallback((start: number, end: number) => {
    setSearchParams((prev) => ({
      ...removeExistingParamsArrayValue(prev, "shipping_timestamp_difference_in_minute", start),
      shipping_timestamp_difference_in_minute: start,
      shipping_timestamp_difference_end_in_minute: end,
    }));
  }, [setSearchParams]);
  
  return (<div className={"column time"}>
    <div className={"title"}>
      {t("shop")}
    </div>
    <TimeFilter
      start={timeStart}
      end={timeEnd}
      onSearch={handleFilterByMinute}
    />
    <Checkbox.Group
      value={value}
      className={"wrapper-rd-wh-sm check"}
      onChange={handleChangeChecked}
    >
      {listData && listData.length > 0 ? listData.map((s, idx) => (<Checkbox
        key={"check" + idx}
        className={"item"}
        data-cy="homeManageCheckbox"
        value={s.uuid}
      >
        {s.name}
      </Checkbox>)) : isLoading || "데이터가 없습니다"}
    </Checkbox.Group>
  </div>);
});

export default SellerTimeFilter;
